import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Customer-side breadcrumb. Same .breadcrumb styling the admin already
 * uses (App.css → .breadcrumb a / span), but with a "בית" anchor that
 * points to the customer root.
 *
 * Usage:
 *   <CustomerBreadcrumb items={[
 *     { label: 'מפעל ראשי', to: '/sites/3' },
 *     { label: 'קבוצות' },
 *   ]} />
 *
 * The last item without a `to` renders as plain text (current page).
 */
function CustomerBreadcrumb({ items = [] }) {
  return (
    <div className="breadcrumb">
      <Link to="/">בית</Link>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <span>/</span>
          {it.to ? <Link to={it.to}>{it.label}</Link> : <span>{it.label}</span>}
        </React.Fragment>
      ))}
    </div>
  );
}

export default CustomerBreadcrumb;
